(function ($) {
  DJ.addBehavior('btnMapModal', '.btn-map-modal', {
    attach: function () {
      const $button = $('.btn--modal', $(this));
      const $modalContent = $('.cems-modal', $(this));
      const evt = window.document.createEvent('UIEvents');
      evt.initUIEvent('resize', true, false, window, 0);

      /**
       * Close modal.
       */
      const onClose = () => {
        $modalContent.removeClass('cems-modal--opened');
        document.getElementsByTagName('html')[0].classList.remove('html--locked');
        $('body').off('click.bodyCloseMapModal');
        $(document).off('keydown.escCloseMapModal');
      };

      /**
       * Close modal on body click.
       */
      const onBodyClick = () => {
        $('body').on('click.bodyCloseMapModal', (e) => {
          if (!($(e.target).closest('.cems-modal__content').length)) {
            onClose();
          }
        });
      };

      /**
       * Close modal on esc key press.
       */
      const onEscKeyPress = () => {
        $(document).on('keydown.escCloseMapModal', (e) => {
          if (e.code === 'Escape') {
            onClose();
          }
        });
      };

      /**
       * Open modal by click on a button.
       * HTML and body are locked(not possible to scroll) while the modal is opened.
       */
      $button.on('click', (e) => {
        e.preventDefault();
        document.getElementsByTagName('html')[0].classList.add('html--locked');
        const bodyTimer = setTimeout(() => {
          $modalContent.addClass('cems-modal--opened');
          window.dispatchEvent(evt);

          onBodyClick();
          onEscKeyPress();
          clearTimeout(bodyTimer);
        }, 50);
      });

      /**
       * Close modal on a close button click.
       */
      $('body').on('click', '.cems-modal__close', () => {
        onClose();
      });
    }
  });
})(jQuery);
